export const invoicesBackups = {
	title: "Respaldos",
	description: "Archivos de facturas fiscales emitidas por mes.",
	filters: {
		fiscalProfile: {
			label: "Perfil fiscal",
			placeholder: "Busque por perfil fiscal",
		},
	},
	table: {
		fiscalProfile: "Perfil fiscal",
		month: "Mes",
		files: "Archivos",
		downloadDanfes: "Descarga de DANFEs",
		downloadXmls: "Descarga de XMLs",
		unavaliable: "no disponible",
	},
};
